import { createLucideIcon } from "lucide-react";

export const ArrowUp = createLucideIcon(
    "arrow-up",
    [
        [
            "path",
            {
                d: "M12 19V5",
                key: "x0mq9r",
            },
        ],
        [
            "path",
            {
                d: "m5 12 7-7 7 7",
                key: "hav0vg",
            },
        ],
    ],
);
